<template>
  <div class="text-c">
    <van-image class="NodataImg" :src="empty" v-if="empty != ''" />
    <p class="f-s-8 text-c" :style="{ color: color }">{{ text }}</p>
    <van-button class="xz-button-info m-t-10 btnClass m-t-075" @click="btnClick" v-if="path != ''">
      {{ btnText }}
    </van-button>
  </div>
</template>

<script>
export default {
  props: {
    text: {
      type: String,
      default: "暂无数据",
    },
    color: {
      type: String,
      default: "#73787F",
    },
    btnText: {
      type: String,
      default: "立即查看",
    },
    path: {
      type: String,
      default: "",
    },
    empty: {
      // type:String,
      default: "",
    },
  },
  data() {
    return {};
  },
  methods: {
    btnClick() {
      if (localStorage.getItem("setToken") == null) {
        this.goLogin();
        return false
      }
      if (this.path == "/BIMList") {
        this.$store.commit("Live/editGoLiveNum");
        this.$router.push({
          path: "/liveList",
          query: {
            BIMData: true,
          },
        });
      } else if (this.path == "/liveList") {
        this.$store.commit("Live/editGoLiveNum");
        this.$router.push("/liveList");
      } else {
        this.$router.push(this.path);
      }
    },
  },
};
</script>

<style scoped>
.btnClass {
  border-radius: 1rem;
  width: 10rem;
  
box-shadow: 0rem 0.3rem 0.55rem 0rem rgba(253, 125, 20, 0.4);
border:none
}
.NodataImg {
  width: 50%;
  margin-top: 15%;
}
</style>